import { ActiveEnvironmentApi } from './activeEnvironmentApi'

function emailActiveEnvironment (email) {
    return ActiveEnvironmentApi.emailActiveEnvironment(email).then(response => response.data);
}

export const ActiveEnvironmentService = { emailActiveEnvironment }
